var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "TableList",
        {
          attrs: {
            columns: _vm.tabPaneConfig[_vm.tabKey - 1].columns,
            tableData: _vm.tabPaneConfig[_vm.tabKey - 1].tableData,
            loading: _vm.tabPaneConfig[_vm.tabKey - 1].loading,
            scroll: false,
            pagination: _vm.tabPaneConfig[_vm.tabKey - 1].pagination,
          },
          on: { change: _vm.handleTableChange },
          scopedSlots: _vm._u([
            {
              key: "action",
              fn: function ({ record }) {
                return [
                  _c(
                    "div",
                    { staticClass: "action-detail" },
                    [
                      _c(
                        "span",
                        {
                          style: { opacity: record.status == 3 ? 0.5 : 1 },
                          on: {
                            click: function ($event) {
                              return _vm.idoneIt(record)
                            },
                          },
                        },
                        [_vm._v("\n          我已完成\n        ")]
                      ),
                      _c("a-divider", { attrs: { type: "vertical" } }),
                      _c(
                        "span",
                        {
                          on: {
                            click: function ($event) {
                              return _vm.viewContent(record)
                            },
                          },
                        },
                        [_vm._v("查看详情")]
                      ),
                    ],
                    1
                  ),
                ]
              },
            },
          ]),
        },
        [
          _c(
            "div",
            {
              staticClass: "query-area",
              attrs: { slot: "queryArea" },
              slot: "queryArea",
            },
            [
              _c(
                "div",
                [
                  _c("j-dict-select-tag", {
                    staticStyle: { width: "170px", "margin-right": "15px" },
                    attrs: {
                      placeholder: "请选择年级",
                      dictCode:
                        "school_grade,grade_name,id,0=delete_flag order by sort_order",
                      isShowEmpty: false,
                    },
                    model: {
                      value: _vm.queryParam.gradeId,
                      callback: function ($$v) {
                        _vm.$set(_vm.queryParam, "gradeId", $$v)
                      },
                      expression: "queryParam.gradeId",
                    },
                  }),
                  _c("a-input-search", {
                    staticClass: "search-space",
                    staticStyle: { width: "170px" },
                    attrs: { placeholder: "请输入学生名字" },
                    on: { change: _vm.searchName },
                    model: {
                      value: _vm.queryParam.studentName,
                      callback: function ($$v) {
                        _vm.$set(_vm.queryParam, "studentName", $$v)
                      },
                      expression: "queryParam.studentName",
                    },
                  }),
                  _c(
                    "a-button",
                    {
                      attrs: { type: "primary" },
                      on: { click: _vm.queryTable },
                    },
                    [_vm._v("查询")]
                  ),
                ],
                1
              ),
            ]
          ),
        ]
      ),
      _c("DetailContent", { ref: "detailContentRef" }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }